<template>
    <div class="loading" v-if="loading">
        <v-progress-circular indeterminate color="#de5d0a"></v-progress-circular>
    </div>
    <div class="containers" v-else>
        <div class="payment">
            <div  style="">
                <!-- border-bottom: 1px solid #C6C6C6; -->
                <div class="cancel-booking-orderId" style=" padding-bottom: 16px;">
                    <div class="cancel-booking" @click="cancelBooking">
                        {{ $t('message.cancelBooking') }}
                    </div>
                    <div class="orderId">
                        <!-- <div class="order-id-transaction">
                           <span> {{ $t('message.orderId') }}: {{ transactionId }}</span>
                       </div>
                       <div class="expired-transaction-timeout">
                           <span> {{ $t('message.completeYourPaymentbeforetimeout') }}: <span style="color: #DE5D0A;">{{ timesetTransa }}</span> </span>
                       </div> -->
                    </div>
                </div>
                <div class="row mt-8" style="position: relative; margin: 0%;">
                    <div v-html="paymentFormPost" style="display: none;"></div>
                    <div class="col-lg-5 col-md-5 col-sm-12">
                        <div class="row"
                            style="background: #FFFFFF !important; border-radius: 8px; opacity: 1; z-index: 100;">
                            <div class="col-lg-12 col-md-12 col-sm-12" style="padding-bottom: 16px;">
                                <div class="left">
                                    <div class="trip-sum">{{ $t('message.tripsummary') }}</div>
                                    <div class="all-info">{{ $t('message.billingDetail') }}</div>
                                    <div class="all-info d-flex">
                                        <div style="width: 35%;">
                                            {{ $t('message.orderId') }}:
                                        </div>
                                        <div style="width: 65%;">
                                            {{ transactionId }}
                                        </div>
                                    </div>
                                    <div class="all-info d-flex">
                                        <div style="width: 35%;">
                                            {{ $t('message.email') }}:
                                        </div>
                                        <div style="width: 65%;">
                                            {{ getEmail() }}
                                        </div>

                                    </div>
                                    <div>
                                        <div class="all-info d-flex" v-if="tleFalse">
                                            <div style="width: 35%;">{{ $t('message.tel') }}:</div>
                                            <div style="width: 65%;">{{ phone }}</div>
                                        </div>
                                        <div class="all-info" v-else></div>
                                    </div>


                                    <div>
                                        <div class="all-info" style="border: 0.4px solid #C6C6C6;"></div>
                                        <!-- <div class="all-info"><img style="width: 100%;" src="@/assets/Line_11.png" alt=""></div> -->
                                        <div class="all-info">{{ getDestinationFrom() }} - {{ getdestinationToName() }}
                                        </div>
                                        <div class="all-info">{{ getDateFrom() }} ({{ convertTimes(getDeparture()) }})
                                        </div>
                                        <div class="all-info">{{ $t('message.numberOfPassenger') }} : {{ getSeatNum() }}
                                        </div>
                                        <div class="all-info">{{ $t('message.seatNumber') }} : {{ getSeatLabel() }}
                                        </div>
                                    </div>
                                    <div v-if="returnTrip">
                                        <!-- <div class="all-info" style="border: 0.4px dotted #C6C6C6;"></div> -->
                                        <div class="all-info"><img style="width: 100%;" src="@/assets/Line112.png"
                                                alt=""></div>
                                        <div class="all-info">{{ getdestinationToName() }} - {{ getDestinationFrom() }}
                                        </div>
                                        <div class="all-info">{{ getDateTo() }} ({{ convertTimes(getDepartureBack()) }})
                                        </div>
                                        <div class="all-info">{{ $t('message.numberOfPassenger') }} : {{
                                            getSeatNumBack() }}</div>
                                        <div class="all-info">{{ $t('message.seatNumber') }} : {{ getSeatLabelBack() }}
                                        </div>
                                    </div>
                                    <!-- <div class="all-info" v-if="getTotalLuckeydraw() != 0">Lucky Ticket: $   {{ getTotalLuckeydraw() }}</div> -->
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-12"></div>
                    <div class="col-lg-6 col-md-5 col-sm-12">
                        <div class="passDetails">
                            <!-- <div class="number">1</div> -->
                            <div class="title-pass">{{ $t('message.paymentMethod') }}</div>
                        </div>
                        <div style="font-size: 16px;font-weight: 500;margin-top: 20px;">{{
                            $t('message.choosePaymentMethod') }}</div>
                        <!-- <form action=""> -->
                        <div class="select-radio">
                            <v-radio-group v-model="radioGroup">
                                <div class="card-select-payment">
                                    <div class="img-card">
                                        <img src="@/assets/KHQR.svg" alt="">
                                    </div>
                                    <div class="text">
                                        <div class="title" style="line-height: 20px;">
                                            {{ $t('message.abakhqr') }}
                                        </div>
                                        <div class="txt">
                                            {{ $t('message.desabakhqr') }}
                                        </div>
                                    </div>
                                    <div class="radios">
                                        <v-radio color="#DE5D0A" :value="5"
                                            style="position: absolute;top: 0;right: 0;width: 100%;height: 100%;padding-left: 88%;"></v-radio>
                                    </div>
                                </div>
                                <!-- <div class="card-select-payment">
                                    <div class="img-card">
                                       
                                        <svg width="40" height="25" viewBox="0 0 40 25" fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <rect width="40" height="25" fill="url(#pattern0_6918_71)" />
                                            <defs>
                                                <pattern id="pattern0_6918_71" patternContentUnits="objectBoundingBox"
                                                    width="1" height="1">
                                                    <use xlink:href="#image0_6918_71" transform="scale(0.0125 0.02)" />
                                                </pattern>
                                                <image id="image0_6918_71" width="80" height="50"
                                                    xlink:href="data:image/png;base64,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" />
                                            </defs>
                                        </svg>

                                    </div>
                                    <div class="text">
                                        <div class="title" style="line-height: 20px;">
                                            {{ $t("message.ABAPay") }}
                                        </div>
                                        <div class="txt">
                                            {{ $t('message.scanpaybyaba') }}
                                        </div>
                                    </div>
                                    <div class="radios">
                                        <v-radio color="#DE5D0A" :value="0"
                                            style="position: absolute;top: 0;right: 0;width: 100%;height: 100%;padding-left: 88%;"></v-radio>
                                    </div>
                                </div> -->
                                <div class="card-select-payment">
                                    <div class="img-card">
                                        <img src="@/assets/generic.svg" alt="">
                                    </div>
                                    <div class="text">
                                        <div class="title">
                                            {{ $t('message.creditDebitCard') }}
                                        </div>
                                        <div class="txt">
                                            <img src="@/assets/4_Cards.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="radios">
                                        <v-radio color="#DE5D0A" :value="6"
                                            style="position: absolute;top: 0;right: 0;width: 100%;height: 100%;padding-left: 88%;"></v-radio>
                                    </div>
                                </div>
                                <div class="card-select-payment">
                                    <div class="img-card">
                                        <img src="@/assets/wing_back_pay.jpg"
                                            style="width: 40px;height: 30px;border-radius: 4px;" alt="">
                                    </div>
                                    <div class="text">
                                        <div class="title" style="line-height: 20px;">
                                            {{ $t("message.wingBank") }}
                                        </div>
                                        <div class="txt">
                                            {{ $t('message.desWingBank') }}
                                        </div>
                                    </div>
                                    <div class="radios">
                                        <v-radio color="#DE5D0A" :value="4"
                                            style="position: absolute;top: 0;right: 0;width: 100%;height: 100%;padding-left: 88%;"></v-radio>
                                    </div>
                                </div>
                                <!-- <div class="card-select-payment">
                                    <div class="img-card">
                                        <img src="@/assets/ACLEDA_PAY.svg"
                                            style="width: 40px;height: 30px;border-radius: 4px;" alt="">
                                    </div>
                                    <div class="text">
                                        <div class="title" style="line-height: 20px;">
                                            {{ $t("message.acleda") }}
                                        </div>
                                        <div class="txt">
                                            {{ $t('message.acledascan') }}
                                        </div>
                                    </div>
                                    <div class="radios">
                                        <v-radio color="#DE5D0A" :value="7"
                                            style="position: absolute;top: 0;right: 0;width: 100%;height: 100%;padding-left: 88%;"></v-radio>
                                    </div>
                                </div> -->
                            </v-radio-group>
                        </div>

                        <!-- <div class="all-payment">
                            <div class="type-payment">{{ $t('message.paymentMethod') }}:</div>
                            <div class="price-payment">
                                <span class="all-style" v-if="radioGroup == 4">{{ $t('message.wingBank') }}</span>
                                <span class="all-style" v-if="radioGroup == 5">{{ $t('message.abakhqr') }}</span>
                                <span class="all-style" v-if="radioGroup == 6">{{ $t('message.creditDebitCard')
                                    }}</span> -->
                                <!-- just test -->
                                <!-- <span class="all-style" v-if="radioGroup == 7">{{ $t('message.acleda') }}</span> -->
                                <!-- <span class="all-style" v-if="radioGroup == 0">{{ $t('message.ABAPay') }}</span> -->
                            <!-- </div>
                        </div> -->
                        <div class="container-total">
                            <div class="summary-grid">
                                <div class="summary-row">
                                    <div class="summary-label">{{ $t('message.paymentMethod') }}:</div>
                                    <div class="summary-value">
                                        <span v-if="radioGroup == 4">{{ $t('message.wingBank') }}</span>
                                        <span v-if="radioGroup == 5">{{ $t('message.abakhqr') }}</span>
                                        <span v-if="radioGroup == 6">{{ $t('message.creditDebitCard') }}</span>
                                        <!-- <span v-if="radioGroup == 7">ACLEDA Bank</span> -->
                                    </div>
                                </div>
                         
                                <div v-if="showFareSummary" style="line-height: 2.5;">
                                    <div class="summary-row">
                                        <div class="summary-label">{{ $t('message.grandTotal') }}:</div>
                                        <div class="summary-value">${{ getSubTotal() }}</div>
                                    </div>
                                    
                                    <div class="summary-row">
                                        <div class="summary-label" style="border-bottom: 1px solid #C6C6C6;">{{ $t('message.discount') }}:</div>
                                        <div class="summary-valuedis" style="">${{ getDiscount() }}</div>
                                    </div>
                                    
                                    <div class="summary-row">
                                        <div class="summary-label">{{ $t('message.serviceFee') }} (0%):</div>
                                        <div class="summary-value">$0.00</div>
                                    </div>
                                    <div class="summary-row">
                                        <div class="summary-label">{{ $t('message.total') }}:</div>
                                        <div class="summary-value"> {{ '$' + formatPrice(getTotal()) }} </div>
                                    </div>
                                </div>

                                <div class="summary-row total-amount">
                                    <div class="summary-label">{{ $t('message.totalAmount') }}:</div>
                                    <div class="summary-value">
                                        {{ '$' + formatPrice(getTotal()) }} 
                                        <span class="toggle-summary" @click="toggleFareSummary">
                                            ({{ showFareSummary ? this.$t('message.showless') : this.$t( 'message.fareSummary' )}})
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <span>{{ $t('message.desTermCoditionPrivacyPolicy') }} <a href="/term-condition"
                                    target="_blank" style="color: #312783;">{{ $t('message.termCondition') }}</a> {{
                                        $t('message.desTermCoditionPrivacyPolicyAnd') }} <a href="/privacy-policy"
                                    target="_blank" style="color: #312783;">{{ $t('message.privacyPolicy') }}</a></span>
                        </div>
                        <button :disabled="disable" class="book-pay-now" @click="getProcessPayment">
                            {{ $t(titleButton) }}
                        </button>
                    </div>

                    <transition name="fade">
                        <div v-if="showPaymentFrame" class="payment-frame">
                            <div class="set-wi-he">
                                <i class="fa-solid fa-xmark" @click="showPaymentFrameFal"
                                    style="cursor: pointer;position: absolute;top: 31px;right: 4%;font-size: 20px;"></i>
                                <iframe style="border-radius: 20px;" :src="paymentUrl" frameborder="0" width="100%"
                                    height="100%"></iframe>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>
<script src="https://checkout.payway.com.kh/plugins/checkout2-0.js"></script>// production
<!-- <script src="https://checkout.payway.com.kh/plugins/checkout2-0-dev.js"></script> // qa -->
<script>
import axios from 'axios';
import qs from 'qs';
import { loadScript } from "vue-plugin-load-script";
export default {
    data() {
        return {
            loading: false,
            tleFalse: false,
            phone: "",
            info: [],
            radioGroup: 5,
            isActive: false,
            returnTrip: false,
            showDiscount: false,
            showDiscountback: false,
            discount: 5,
            showPaymentFrame: false,
            titleButton:"message.payNow",
            paymentUrl: "",
            urlABA: 'https://checkout.payway.com.kh/plugins/checkout2-0.js', // production
            // urlABA: 'https://checkout.payway.com.kh/plugins/checkout2-0-dev.js', // qa
            disable:false,
            transactionId: this.$route.query.transactionId,
            paymentFormPost: "",
            seconds: 360,
            timesetTransa: '',

            disPercent: localStorage.getItem('disPercent'),
            disPercentBack: localStorage.getItem('disPercentBack'),
            info1: localStorage.getItem("discount"),
            showFareSummary: false,
        }
        
    },
    methods: {
        convertTimes(time) {
            const [hours, minutes] = time.split(':');
            return `${hours}:${minutes}`;
        },
        startTimer() {
            this.timer = setInterval(() => {
                if (this.seconds > 1) {
                    this.seconds--;
                    this.timesetTransa =  this.formatTime(this.seconds);
                } else {
                    clearInterval(this.timer);
                // Optionally, you can perform an action when the countdown reaches zero
                }
            }, 1000);
        },
        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60);
            const remainingSeconds = seconds % 60;
            return `${this.pad(minutes)}:${this.pad(remainingSeconds)}`;
        },
        pad(value) {
            return value < 10 ? `0${value}` : value;
        },
        getCheck() {
            if(localStorage.getItem('dateTo') != null){
                this.returnTrip = true;
            }else{
                this.returnTrip = false;
            }
        },
        getTotalLuckeydraw() { return localStorage.getItem('totalluckydraw'); },
        getDestinationFrom() {
            if( localStorage.getItem('lang') == 'ch'){
                return localStorage.getItem('departureFromNameCn');
            }else if( localStorage.getItem('lang') == 'kh'){
                return localStorage.getItem('departureFromNameKh');
            }else{
                return localStorage.getItem('departureFromName');
            }
        },
        getdestinationToName() {
            if( localStorage.getItem('lang') == 'ch'){
                return localStorage.getItem('destinationToNameCn');
            }else if( localStorage.getItem('lang') == 'kh'){
                return localStorage.getItem('destinationToNameKh');
            }else{
                return localStorage.getItem('destinationToName');
            }
        },
        getDateFrom() { return localStorage.getItem('dateFrom');},
        getDeparture() { return localStorage.getItem('departure');},
        getDateTo() { return localStorage.getItem('dateTo');},
        getDepartureBack() { return localStorage.getItem('departureback');},    
        getTotal() { 
            if(localStorage.getItem("priceOriginal") == "" || localStorage.getItem("priceOriginal") == null){
                this.showDiscount = true;
                return parseFloat(localStorage.getItem('resultTotal')) - this.disConut() + parseFloat(localStorage.getItem('totalluckydraw')) ;
            }else{
                this.showDiscount = false;
                return parseFloat(localStorage.getItem('resultTotal')) +  parseFloat(localStorage.getItem('totalluckydraw')) ;
            }
        },   
        grandTotal() {
            return localStorage.getItem('resultTotal');
        },
        disConut() {
            let totals = parseFloat(localStorage.getItem('discount')) * parseInt(this.getSeatNum());
            return totals;
        },
        
       
        totalDiscosunt() {
            if((localStorage.getItem("priceOriginalback") == "" || localStorage.getItem("priceOriginalback") == null) && (localStorage.getItem("priceOriginal") == "" || localStorage.getItem("priceOriginal") == null)){
                let totalDiscount = parseFloat(this.disConut()) + parseFloat(this.disConutBack());
                // let calu = totalDiscount * this.discount/100;
                return totalDiscount;
            }else if((localStorage.getItem("priceOriginalback") != "" || localStorage.getItem("priceOriginalback") != null) && (localStorage.getItem("priceOriginal") == "" || localStorage.getItem("priceOriginal") == null)){
                return this.disConut();
            }else if((localStorage.getItem("priceOriginalback") == "" || localStorage.getItem("priceOriginalback") == null) && (localStorage.getItem("priceOriginal") != "" || localStorage.getItem("priceOriginal") != null)){
                return this.disConutBack();
            }else{
                return "0.00";
            }
        },
        getFullName() { return localStorage.getItem('fullname') },
        getEmail() { return localStorage.getItem('email') },
        getPhone() { 
            if(localStorage.getItem("phone") != null && localStorage.getItem("phone") != "") {
                this.tleFalse = true;
                this.phone = localStorage.getItem('phone');
            }else{
                this.tleFalse = false;
            }
            
        },
        getDiscount() {
            const discount = localStorage.getItem("discount");
            if (!discount) {
                // console.log("No discount found in localStorage");
                return "0.00";
            }
            const parsedDiscount = parseFloat(discount);
            return parsedDiscount.toFixed(2);
        },
        getDiscountPercent() {
        const discountPercent = localStorage.getItem("discountPercent");
        return discountPercent ? parseInt(discountPercent) : 0;
    },
    
    getTotal() {
        const total = localStorage.getItem("total");
        return total ? parseFloat(total) : 0;
    },
    
    getSubTotal() {
        const subTotal = localStorage.getItem("subTotal");
        return subTotal;
    },


        getSeatNum() {
            if(localStorage.getItem('seat') != '') {
                let seatNum = localStorage.getItem('seat');
                let seatNumArray = seatNum.split(",");
                return this.seatNum = seatNumArray.length;
            }
        },
        getSeatLabel() {
            if(localStorage.getItem('seatlabel') != '') {
                let size = localStorage.getItem('seatlabel');
                let seatArray = size.split(",");
                let lblSeat = "";
                for (let i = 0; i < seatArray.length; i++) {
                    if (seatArray[i] != ",") {
                        if(i > 0){
                            lblSeat += ", ";
                        }
                        lblSeat += seatArray[i];
                    }
                }
                return this.seatLabel = lblSeat;
            }
        },
        getSeatNumBack() {
            if(localStorage.getItem('seatback') != '') {
                let seatNumBack = localStorage.getItem('seatback');
                let seatNumBackArray = seatNumBack.split(",");
                return this.seatNumBack = seatNumBackArray.length;
            }
        },
        getSeatLabelBack() {
            if(localStorage.getItem('seatlabelback') != '') {
                let size = localStorage.getItem('seatlabelback');
                let seatArray = size.split(",");
                let lblSeat = "";
                for (let i = 0; i < seatArray.length; i++) {
                    if (seatArray[i] != ",") {
                        if(i > 0){
                            lblSeat += ", ";
                        }
                        lblSeat += seatArray[i];
                    }
                }
                return this.seatLabel = lblSeat;
            }
        },

        // Return Trip (one way)
        grandTotalRe() {
            return parseFloat(localStorage.getItem('resultTotal')) + parseFloat(localStorage.getItem('resultTotalBack'));
        },
        disConutBack() {
            let disConutBack = parseFloat(localStorage.getItem('discountBack')) * parseInt(this.getSeatNumBack());
            return disConutBack;
        },
        totalRetureTirp() {
            if((localStorage.getItem("priceOriginalback") == "" || localStorage.getItem("priceOriginalback") == null) && (localStorage.getItem("priceOriginal") == "" || localStorage.getItem("priceOriginal") == null)){
                this.showDiscountback = true;
                let totals = parseFloat(localStorage.getItem('resultTotal')) + parseFloat(localStorage.getItem('resultTotalBack')) - this.totalDiscosunt() +  parseFloat(localStorage.getItem('totalluckydraw')) ;
                return totals;
            }else if((localStorage.getItem("priceOriginalback") != "" || localStorage.getItem("priceOriginalback") != null) && (localStorage.getItem("priceOriginal") == "" || localStorage.getItem("priceOriginal") == null)){
                this.showDiscountback = true;
                let totals = parseFloat(localStorage.getItem('resultTotal')) + parseFloat(localStorage.getItem('resultTotalBack')) - this.disConut() + parseFloat(localStorage.getItem('totalluckydraw')) ;
                return totals;
            }else if((localStorage.getItem("priceOriginalback") == "" || localStorage.getItem("priceOriginalback") == null) && (localStorage.getItem("priceOriginal") != "" || localStorage.getItem("priceOriginal") != null)){
                this.showDiscountback = true;
                let totals = parseFloat(localStorage.getItem('resultTotal')) + parseFloat(localStorage.getItem('resultTotalBack')) - this.disConutBack() + parseFloat(localStorage.getItem('totalluckydraw'));
                return totals;
            }else{
                this.showDiscountback = false;
                return parseFloat(localStorage.getItem('resultTotal')) + parseFloat(localStorage.getItem('resultTotalBack')) ;
            }
        },
        // cut (,)
        formatPrice(value) { let val = (value/1).toFixed(2); return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");},
        showPaymentFrameFal() {
            if (window.confirm(this.$t('message.areyousureyouwanttoclose'))) {
                this.showPaymentFrame = false;
                this.$router.go();
            } else {
                // User clicked Cancel
                // Perform any other action or do nothing
            }
        },
        

        async getProcessPayment() {
            if(this.radioGroup == 0) {
                alert("Please select payment type before click button pay now.");
            }else{
                this.titleButton="Loading";
                this.disable = true;
                const data = { 
                    'code': this.$route.query.transactionId,
                    'paymentMethodId': parseInt(this.radioGroup)
                }
                const url = this.$url + `booking/processPayment`;

                let config = {
                    method: "POST",
                    headers: this.$header,
                    data: qs.stringify(data),
                    url
                };
                axios(config).then((response) => {
                    if (response.status == 200) {
                        if(response.data.header.result == true && response.data.header.statusCode == 200) {  
                            this.titleButton="message.payNow";
                            this.disable = false;
                            this.info = response.data.body;
                              if(this.info.status == 1){ // Ture
                                
                                if(this.radioGroup == 4){
                                    if(response.data.body.request != "") {
                                        window.location.href = response.data.body.request;
                                    }else{
                                        alert("Invaild Payment Method");
                                    }
                                } else {
                                    this.paymentFormPost = response.data.body.request;
                                    loadScript(this.urlABA)
                                    .then(() => {
                                        AbaPayway.checkout();
                                    })
                                    .catch(() => {
                                        console.log("error process payment aba");
                                    });
                                    
                                    // this.showPaymentFrame = true;
                                    // if(this.showPaymentFrame == true) {
                                        // this.paymentUrl = "https://vetticket.utlog.net/payments/busWebsitePaymentProcess/"+this.$route.query.transactionId+"/"+paymentToken;
                                        // this.checkAbaTransaction();
                                        //this.getAbaRequestForm(this.$route.query.transactionId, paymentToken);
                                    // }else{
                                    //     this.showPaymentFrame = false;
                                    // }
                                }
                            } else { // Session Expired
                                alert("Session Expired");
                                this.$router.push("/");
                            }
                        } else { // Error
                            alert("Sorry, the payment process failed. Please try it again.");
                            // this.$router.push("/");
                        }
                    }else {
                        console.log('Not Status 200');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            }
        }, 
       
        // async checkAbaTransaction() {
        //     const data = { 
        //         'transactionId': this.$route.query.transactionId,
        //     }
        //     const url = this.$url + `booking/checkAbaPaymentStatus`;
        //     let config = {
        //         method: "POST",
        //         headers: this.$header,
        //         data: qs.stringify(data),
        //         url
        //     };
        //     axios(config).then((response) => {
        //         if (response.status == 200) {
        //             if(response.data.header.result == true && response.data.header.statusCode == 200) {  
        //                 this.info = response.data.body;
        //                 if(this.info.status == 1){ // Ture
        //                     this.paymentComplete();
        //                 } else { // Session Expired
        //                     setTimeout(() => {
        //                         this.checkAbaTransaction();
        //                     }, 5000);
        //                 }
        //             }
        //         }
        //     }).catch((error) => {
        //         console.log(error);
        //         setTimeout(() => {
        //             this.checkAbaTransaction();
        //         }, 5000);
        //     });
        // },
        async paymentComplete() {
            const discount = localStorage.getItem("discount");
            const data = {
                'transactionId': this.$route.query.transactionId
            }
            
            const url = this.$url + `booking/complete`;
            let config = {
                method: "POST",
                headers: this.$header,
                data: qs.stringify(data),
                url               
            };
            this.clearStorage();
            this.loading  = true;
            axios(config).then((response) => {
                if (response.status == 200) {
                    if(response.data.header.result == true && response.data.header.statusCode == 200) {  
                        this.info = response.data.body;
                        if(this.info.status == 1){ // Complete
                            // this.showPaymentFrame = false;
                            this.$router.push({
                                path: "/payment-success",
                                query: {
                                    transactionId: this.$route.query.transactionId
                                }
                            });
                        } else { // not complete
                            this.loading = false;
                            this.showPaymentFrame = false;
                            alert("Payment Not Success");
                        }
                    } else { // Error
                        this.loading = false;
                        this.showPaymentFrame = false;
                        if (window.confirm("Please try it again.")) {
                            this.cancelBooking();
                        }else{
                            // User clicked Cancel
                            // Perform any other action or do nothing
                        }
                    }
                }
            }).catch((error) => {console.log(error);});
        },
        async cancelBooking() {
            if (window.confirm(this.$t('message.doyouwanttocancelbooking'))) {
                const data = {
                    'transactionId': this.$route.query.transactionId,
                }
                const url = this.$url + `booking/cancel`;
                let config = {
                    method: "POST",
                    headers: this.$header,
                    data: qs.stringify(data),
                    url
                };
                this.loading = true;
                axios(config).then((response) => {
                    this.loading = false;
                    if (response.status == 200) {
                        localStorage.removeItem('handleBrowser');
                        this.clearStorage();
                        // Replace the current history entry with home page to prevent back navigation
                        this.$router.replace("/");
                    }
                }).catch((error) => {console.log(error);});
            }
        },
        clearStorage() {
            localStorage.removeItem("departureFromName");
            localStorage.removeItem("departureFromId");
            localStorage.removeItem("destinationToName");
            localStorage.removeItem("destinationToId");
            localStorage.removeItem("dateFrom");
            localStorage.removeItem("dateTo");

            localStorage.removeItem("price");
            localStorage.removeItem("departure");
            localStorage.removeItem("arrival");
            localStorage.removeItem("duration");
            localStorage.removeItem("journeyid");
            localStorage.removeItem("priceOriginal");

            localStorage.removeItem("priceback");
            localStorage.removeItem("departureback");
            localStorage.removeItem("durationback");
            localStorage.removeItem("arrivalback");
            localStorage.removeItem("journeyidback");
            localStorage.removeItem("priceOriginalback");

            localStorage.removeItem("resultTotal");
            localStorage.removeItem("resultTotalBack");
            localStorage.removeItem("totalluckydraw");

            localStorage.removeItem("seat");
            localStorage.removeItem("seatlabel");
            localStorage.removeItem("seatback");
            localStorage.removeItem("seatlabelback");

            localStorage.removeItem("trips");
            localStorage.removeItem("busTittle");
            localStorage.removeItem('book-again');
            localStorage.removeItem('blog-img');

            localStorage.removeItem("email");
            localStorage.removeItem("phone");
    
         
            localStorage.removeItem('boardingPointLats');
            localStorage.removeItem('boardingPointLongs');
            localStorage.removeItem('dropOffPointLats');
            localStorage.removeItem('dropOffPointLongs');    

            localStorage.removeItem('discount');
            localStorage.removeItem('disPercent');
            localStorage.removeItem('discountBack');
            localStorage.removeItem('disPercentBack'); 
            
            // clear confirm booking
            localStorage.removeItem("boardingPointId");
            localStorage.removeItem("dropOffPointId");
            localStorage.removeItem("boardingPointIdBack");
            localStorage.removeItem("dropOffPointIdBack");
            localStorage.removeItem("gender");

            localStorage.removeItem("selection1");
            localStorage.removeItem("selection2");
            localStorage.removeItem("selection3");
            localStorage.removeItem("selection4");
        },
        toggleFareSummary() {
            this.showFareSummary = !this.showFareSummary;
        }
    },
    created() {
        localStorage.setItem('transactionId', this.$route.query.transactionId);
        // this.startTimer();
        this.getPhone();
        this.getCheck();
    },
    mounted() {
        // Clear any existing history state
        window.history.replaceState(null, '' , '/');
        
        // Handle back button
        window.onpopstate = (event) => {
            event.preventDefault();
            // Show confirmation dialog
            if (window.confirm(this.$t('message.doyouwanttocancelbooking'))) {
                // Clear all storage and state
                localStorage.removeItem('handleBrowser');
                this.clearStorage();
                
                // Clear history and redirect to home
                window.history.pushState(null, '', '/');
                window.history.go(0); // Force page refresh
            } else {
                // If user clicks Cancel, stay on current page
                window.history.pushState(null, '', window.location.href);
            }
        };

        loadScript(this.urlABA);
    },
    beforeDestroy() {
        // Clean up the popstate event listener
        window.onpopstate = null;
    },
    computed: {
        showDiscount() {
            const hasDiscount = localStorage.getItem("discount") !== null;
            return hasDiscount;
        }
    },
}
</script>

<style scoped>
.by-follow a:hover {
    color: #333;
}

.payment {
    padding-top: 100px;
    padding-bottom: 50px;
}
.fare-summary:hover {
    font-size: 14px;
    font-weight: 600;
    color: #1B77F2;
    text-decoration: underline;
    cursor: pointer;
}

.cancel-booking-orderId {
    display: flex;
    align-items: center;
}

.cancel-booking-orderId .cancel-booking {
    width: 50%;
    cursor: pointer;
    font-weight: 600;
    color: #1B77F2;
}

.cancel-booking-orderId .cancel-booking:hover {
    color: #4248e6;
}

.cancel-booking-orderId .orderId {
    /* text-align: end; */
    width: 50%;
}

.cancel-booking-orderId .orderId .order-id-transaction {
    padding-bottom: 15px;

}

.cancel-booking-orderId .orderId .expired-transaction-timeout {
    padding-bottom: 15px;
}

.servicefee {
    position: absolute;
    left: 50%;
    top: 30%;
}

/* right */
.passDetails {
    display: flex;
    align-items: center;
}

.passDetails .number {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 600;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid #312783;
    background: #312783;
}

.passDetails .title-pass {
    /* margin-left: 15px; */
    font-weight: 600;
    font-size: 20px;
    color: #0c2f54;
}

.select-radio .card-select-payment {
    position: relative;
    background: #EEEEF3;
    margin-top: 20px;
    padding: 17px;
    border-radius: 6px;
    display: flex;
    align-items: center;
}

.select-radio .card-select-payment .text .title {
    font-weight: 600;
    font-size: 12px !important;
    color: #424245;
}

.dotted {
    padding-top: 10px;
}

.select-radio .card-select-payment .text .txt {
    font-weight: 400;
    font-size: 12px !important;
    color: #6E6E73;
}

.select-radio .card-select-payment .img-card {
    width: 10%;
}

.select-radio .card-select-payment .text {
    width: 80%;
}

/* .select-radio .card-select-payment .radios {
        display: flex;
        justify-content: end;
        width: 10%;
    } */
@media(width < 960px) {
    .select-radio {
        padding-left: 0px;
    }

    .select-radio .card-select-payment .text {
        padding-left: 20px;
    }
}

@media (width < 457px) {
    .select-radio .card-select-payment {
        padding: 8px;
    }
}

@media(width < 435px) {
    .passDetails .title-pass {
        font-size: 13px;
    }

    .type-payment,
    .text-total {
        width: 40% !important;
      
    }

    .price-payment,
    .price-total {
        width: 60% !important;
    }
}

/* Left */
.left {
    padding-right: 20px;
}

.left .trip-sum {
    color: #0c2f54;
    font-weight: 600;
    font-size: 20px;
    margin-top: 5px;
}

.left .all-info {
    color: #1D1D1D;
    margin-top: 13px;
    font-weight: 545;
    font-size: 16px;
}

.all-payment {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.all-payment .type-payment {
    width: 30%;
}

.all-payment .price-payment {
    width: 70%;
}

.all-payment .price-payment span {
    font-weight: 600;
}

/* container sub total */
.container-total {
    width: 100%;
    padding: 20px 0;
}

.summary-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    width: 100%;
    max-width: 600px;
}

.summary-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    /* border-bottom: 1px solid #eee; */
    align-items: center;
}

.summary-label {
    color: #666;
    font-weight: 500;
    font-size: 14px;
}

.summary-value {
    text-align: left;
    font-weight: 600;
    font-size: 14px;
}
.summary-valuedis{
    border-bottom: 1px solid #C6C6C6; 
    width: 26%;
}

.total-amount {
    border-bottom: none;
    font-size: 16px;
}

.toggle-summary {
    color: #1B77F2;
    font-size: 14px;
    margin-left: 8px;
    cursor: pointer;
    display: inline-block;
}

.toggle-summary:hover {
    text-decoration: underline;
}

@media (max-width: 768px) {
    .summary-grid {
        max-width: 100%;
    }
    
    .summary-row {
        grid-template-columns: 2fr 3fr;
    }
    .summary-value {
    text-align: end;
    font-weight: 600;
    font-size: 14px;
}
.summary-valuedis{
    border-bottom: 1px solid #C6C6C6; 
    width: 100%;
    text-align: end;
    font-weight: 600;
    font-size: 14px;
}

}

.book-pay-now {
    margin-top: 20px;
    border: 1px solid #312783;
    width: 140px;
    border-radius: 4px;
    text-align: center;
    padding: 10px;
    cursor: pointer;
    color: #312783;
    border-color: #312783;
    font-weight: 600;
    transition: 0.5s;
}

.book-pay-now:hover {
    border: 1px solid #DE5D0A;
    color: #fff;
    background: #DE5D0A;
}

.payment-frame {
    padding-left: 30px;
    padding-right: 30px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.set-wi-he {
    position: relative;
    width: 600px;
    height: 600px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fare-details {
    margin-top: 10px;
    padding: 10px;
    background-color: #f8f8f8;
    border-radius: 4px;
    transition: all 0.3s ease;
}

.fare-summary {
    cursor: pointer;
    transition: color 0.3s ease;
}

.fare-summary:hover {
    text-decoration: underline;
}
</style>